export default __webpack_public_path__ + "static/media/home.190e376d.svg";